import React from 'react';
import { Section, SplitScreen } from '../../ui/layouts/SplitScreen';
import Spinner from '../../ui/Spinner';
import Text from '../../ui/Text';
import Headline from '../../ui/Headline';
import Wrapper from '../../ui/Wrapper';
import ValidInput from '../../ui/controls/ValidInput';
import Button from '../../ui/controls/Button';
import { COLORS } from '../../themes';
import userConductor from '../../common/conductors/UserConductor';

import getTexts from 'utils/localization';
const t = getTexts();

class ForgotPassword extends React.Component {
    userNameValidator = null;
    emailValidator = null;

    constructor() {
        super();

        this.state = {
            username: '',
            email: '',
            isPending: false,
        };
    }

    onInputChangeHandler(key, val) {
        let newVal = {};

        newVal[key] = val;

        this.setState(newVal);
    }

    setValidationHandler(fieldName, validator) {
        if (fieldName === 'username') {
            this.userNameValidator = validator;
        } else {
            this.emailValidator = validator;
        }
    }

    onProceedHandler = () => {
        this.userNameValidator();
        this.emailValidator();

        if (this.state.username && this.state.email) {
            this.setState({
                isPending: true,
            });

            userConductor
                .resetPassword(this.state.username, this.state.email)
                .then((res) => {
                    if (res.success) {
                        this.props.showModal(
                            'STATUS_OF_ACTION',
                            2,
                            {
                                success: true,
                                title: t.ForgotPassword.success.title,
                                text: t.ForgotPassword.success.text,
                            },
                            4000
                        );
                    } else {
                        this.props.showModal('STATUS_OF_ACTION', 2, {
                            success: false,
                            title: t.ForgotPassword.error.title,
                            text: t.ForgotPassword.error.text,
                        });
                    }

                    this.setState({
                        isPending: false,
                    });
                });
        }
    };

    componentDidMount() {
        this.props.enableCloseButton(null, COLORS.black);
    }

    startChat = () => {
        window.Intercom('show');
    };

    render() {
        return (
            <SplitScreen minHeight="550px">
                <Section
                    white
                    height="60"
                    rounded="bottom"
                    align="space-evenly"
                >
                    <Wrapper padding="10px 30px">
                        <Headline align="center">
                            {t.ForgotPassword.title}
                        </Headline>

                        <Text align="center">{t.ForgotPassword.text1}</Text>

                        <ValidInput
                            value={this.state.username}
                            validate={{ required: true }}
                            placeholder={t.ForgotPassword.username}
                            onChange={this.onInputChangeHandler.bind(
                                this,
                                'username'
                            )}
                            getValidator={(validator) =>
                                this.setValidationHandler('username', validator)
                            }
                        />
                        <ValidInput
                            value={this.state.email}
                            validate={{ required: true, email: true }}
                            placeholder={t.ForgotPassword.email}
                            onChange={this.onInputChangeHandler.bind(
                                this,
                                'email'
                            )}
                            getValidator={(validator) =>
                                this.setValidationHandler('email', validator)
                            }
                        />
                    </Wrapper>
                </Section>

                <Section height="40" transperent align="start">
                    <Wrapper margin="-40px auto 10px" align="center">
                        {this.state.isPending === false ? (
                            <Button
                                white
                                size="x2"
                                rounded
                                width="200px"
                                shadow="10"
                                onClick={this.onProceedHandler}
                            >
                                {t.ForgotPassword.proceed}
                            </Button>
                        ) : (
                            <Wrapper margin="30px auto -30px">
                                <Spinner size="x2" white />
                            </Wrapper>
                        )}
                    </Wrapper>
                    <Wrapper padding="10px 30px" align="center">
                        <Text size="x05" white align="center">
                            {t.ForgotPassword.text2}
                        </Text>
                        <Button
                            accent
                            size="x2"
                            rounded
                            width="200px"
                            onClick={this.startChat}
                        >
                            {t.ForgotPassword.startChat}
                        </Button>
                    </Wrapper>
                </Section>
            </SplitScreen>
        );
    }
}

export default ForgotPassword;
